import React, { useMemo } from 'react';
import { Row, Col, Select, Space } from 'antd';
import PropTypes from 'prop-types';

function TableSubmissionPreload({ configProps, updateConfig, sections = [], hideTitle }) {
  const submissionDropdownOptions = useMemo(() => {
    return sections.flatMap(({ name: sectionName, fields }) =>
      (fields ?? []).reduce((acc, field) => {
        const {
          id,
          selectedType,
          configProps: { dataType, title } = {},
        } = field;
        if (selectedType !== 'dropdown' || dataType !== 'CompletedForms') return acc;
        acc.push({ value: id, label: `${sectionName} - ${title}` });
        return acc;
      }, []),
    );
  }, [sections]);

  const onChange = (value) => updateConfig({ preloadSubmissionDropdown: value });

  return (
    <Space direction="vertical">
      {!hideTitle && <Row style={{ marginTop: 10 }}>Filter New Entries</Row>}
      <Row align="middle" gutter={10} style={{ marginLeft: hideTitle ? 0 : 10 }}>
        <Col>By Submission Dropdown</Col>
        <Col>
          <Select
            style={{ width: 500 }}
            placeholder="Select a Submission Dropdown Field"
            options={submissionDropdownOptions}
            value={configProps.preloadSubmissionDropdown}
            onChange={onChange}
            allowClear
            showSearch
            optionFilterProp="label"
          />
        </Col>
      </Row>
    </Space>
  );
}

TableSubmissionPreload.propTypes = {
  configProps: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
  sections: PropTypes.array,
  hideTitle: PropTypes.bool,
};
TableSubmissionPreload.defaultProps = { sections: [], hideTitle: false };

export default TableSubmissionPreload;
